import * as actions from './actionsSagas';
import * as constants from './constants';
import reducer from './reducer';
import sagas from './sagas';
import * as selectors from './selectors';

export default { actions, selectors, constants, sagas, reducer };
